import React from 'react';
import { Link } from 'react-router-dom';
import AuthShell from './AuthShell';
import { Translate as t } from '../../config/Translate';

const ForgotPasswordSent = () => {
    return (
        <AuthShell title={t('auth.label.checkYourEmail')} description={t('auth.message.info.checkYourEmailDesc')}>
            <a className="rg-login-btn-signin" href="/Login">{t('common.button.done')}</a>
            <div className="rg-login-row-between" style={{ justifyContent: 'center', margin: '18px 0 0' }}>
                <span>{t('auth.message.info.didntReceiveEmail')}&nbsp;<a className="rg-login-link" href="/ForgotPassword">{t('common.button.resend')}</a></span>
            </div>
            <div className="rg-login-row-between" style={{ justifyContent: 'center', margin: '12px 0 0' }}>
                <Link to="/Login" className="rg-login-link">{t('common.button.back')}</Link>
            </div>
        </AuthShell>
    )
}

export default ForgotPasswordSent;